import Box from "@mui/material/Box";
import Skeleton from "@mui/material/Skeleton";
import { OrderListTemplate } from "./OrderListTemplate";

const BAR_AREAS: [string, number | string][] = [
  ["orderNumber", "70%"],
  ["customer", "50%"],
  ["source", 64],
  ["status", 110],
  ["orderDate", "60%"],
  ["lastSynced", "60%"],
];

/** A placeholder order row shown while the list loads, on the same grid as OrderListRow. */
export const OrderListSkeletonRow = () => {
  return (
    <Box
      sx={{
        borderBottom: 1,
        borderColor: "divider",
      }}
    >
      <OrderListTemplate
        sx={{
          py: 1,
        }}
      >
        <Skeleton
          height={20}
          sx={{ gridArea: "expand" }}
          variant="circular"
          width={20}
        />
        {BAR_AREAS.map(([area, width]) => (
          <Skeleton
            height={24}
            key={area}
            sx={{ gridArea: area }}
            width={width}
          />
        ))}
      </OrderListTemplate>
    </Box>
  );
};
